// Connect-consent modal — future/past capture checkboxes with the "future required"
// guard. Moved verbatim from SourcesSurface (was `ConsentPopup`) so the onboarding
// chat branch and the Sources page share one consent surface.

import { useState, useEffect } from 'react';
import { SOURCE_META } from '../../lib/sources';
import { SourceIcon } from './SourceIcon';

export function ConsentModal({ sourceId, onConfirm, onCancel }: {
  sourceId: string | null;
  onConfirm: (consentFuture: boolean, consentPast: boolean) => void;
  onCancel: () => void;
}) {
  const [consentFuture, setConsentFuture] = useState(true);
  const [consentPast, setConsentPast] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (sourceId) {
      setConsentFuture(true);
      setConsentPast(true);
      setError(null);
    }
  }, [sourceId]);

  if (!sourceId) return null;
  const meta = SOURCE_META[sourceId] || { name: sourceId, trustCopy: '', signal: '' };

  function handleConfirm() {
    if (!consentFuture) {
      setError('Please allow Terum to record future conversations to connect this source');
      return;
    }
    setError(null);
    onConfirm(consentFuture, consentPast);
  }

  return (
    <div onClick={onCancel} style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, backdropFilter: 'blur(4px)',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: 'var(--bg2)', border: '1px solid var(--border-b)',
        borderRadius: 12, width: '90%', maxWidth: 420, padding: 24,
        boxShadow: '0 24px 64px rgba(0,0,0,0.5)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          <SourceIcon id={sourceId} size={32} />
          <div style={{ fontFamily: 'var(--display)', fontSize: 18, fontWeight: 600, color: 'var(--text)' }}>
            Connect {meta.name}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 16 }}>
          <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}
            onClick={e => e.stopPropagation()}>
            <input type="checkbox" checked={consentFuture} onChange={e => { setConsentFuture(e.target.checked); setError(null); }}
              style={{ marginTop: 2, accentColor: 'var(--accent)', width: 16, height: 16, flexShrink: 0 }} />
            <span style={{ fontFamily: 'var(--sans)', fontSize: 13, color: 'var(--text2)', lineHeight: 1.5 }}>
              Allow Terum to record and store future conversations
            </span>
          </label>

          <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}
            onClick={e => e.stopPropagation()}>
            <input type="checkbox" checked={consentPast} onChange={e => { setConsentPast(e.target.checked); setError(null); }}
              style={{ marginTop: 2, accentColor: 'var(--accent)', width: 16, height: 16, flexShrink: 0 }} />
            <span style={{ fontFamily: 'var(--sans)', fontSize: 13, color: 'var(--text2)', lineHeight: 1.5 }}>
              Allow Terum to read the last 30 days of conversations
            </span>
          </label>
        </div>

        {error && (
          <div style={{
            fontFamily: 'var(--sans)', fontSize: 12, color: 'var(--rose)', lineHeight: 1.5,
            padding: '8px 12px', background: 'rgba(255,107,138,0.08)', borderRadius: 6,
            marginBottom: 16,
          }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10 }}>
          <button className="v2-btn" style={{ flex: 1, textAlign: 'center' }} onClick={onCancel}>Cancel</button>
          <button className="v2-btn accent" style={{ flex: 1, textAlign: 'center' }} onClick={handleConfirm}>Connect</button>
        </div>
      </div>
    </div>
  );
}
